// extracted by mini-css-extract-plugin
export default {"external-id-text":"CollectionExternalId_external-id-text__DpJL2","externalIdText":"CollectionExternalId_external-id-text__DpJL2"};